import React from "react";

const InfoBlock: React.FC<{text: string}> = ({ text }) => (
  <div className="text-center text-white text-[16px] opacity-80 mb-4">
    {text}
  </div>
);

export default InfoBlock; 
